<template>
    <div>
        <h3 class="text-center m-b-30">Sobre o lugar que você está procurando</h3>

        <div class="account-content">
            <div class="row m-b-10">
                <div class="col-xs-12 col-sm-6">
                    <div class="form-group" v-bind:class="{'has-error': errors.has('moving_date')}">
                        <label for="moving_date" class="control-label">Data de Mudança</label>
                        <date-picker
                            v-model="form.moving_date"
                            :disabled-date="disabledDate"
                            :open.sync="open_picker"
                            value-type="format"
                            format="DD/MM/YYYY">
                                <template v-slot:input>
                                    <input type="tel"
                                        class="form-control"
                                        data-vv-as="Data de Mudança"
                                        autocomplete="off"
                                        v-validate="'date_format:dd/MM/yyyy'"
                                        v-mask="'##/##/####'"
                                        placeholder="dd/mm/aaaa"
                                        @input="dateChange"
                                        v-model="form.moving_date" name="moving_date"/>
                                </template>
                        </date-picker>
                        <span class="help-block text-left" v-show="errors.has('moving_date')">
                            <strong>{{ errors.first('moving_date') }}</strong>
                        </span>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6">
                    <div class="form-group" v-bind:class="{'has-error': errors.has('staying_time')}">
                        <label for="staying_time" class="control-label">Tempo de Permanência</label>
                        <select class="form-control" v-model="form.staying_time" data-vv-as="tempo de permanência" v-validate="'required'" name="staying_time">
                            <option value="">Selecione</option>
                            <option>Menos de 1 mês</option>
                            <option>Até 3 meses</option>
                            <option>Até 6 meses</option>
                            <option>Mais de 6 meses</option>
                            <option>Indeterminado</option>
                        </select>
                        <span class="help-block text-left" v-show="errors.has('staying_time')">
                            <strong>{{ errors.first('staying_time') }}</strong>
                        </span>
                    </div>
                </div>

            </div>
            <div class="row m-b-10">
                <div class="col-xs-12 col-md-6">
                    <div class="form-group" v-bind:class="{'has-error': errors.has('rent_price')}">
                        <label for="rent_price" class="control-label">Qual o valor máximo do aluguel?</label>
                        <money v-model="form.rent_price" value="" name="rent_price" class="form-control" data-vv-as="aluguel" v-validate="'required|min_value:1|max_value:20000'" data-vv-name="rent_price" v-bind="money"></money>
                        <span class="help-block text-left" v-show="errors.has('rent_price')">
                            <strong>{{ errors.first('rent_price') }}</strong>
                        </span>
                    </div>
                </div>
            </div>

            <div class="row m-b-10">
                <div class="col-xs-12">
                    <div class="form-group" v-bind:class="{'has-error': errors.has('description')}">
                        <label for="description" class="control-label">Descrição</label>
                        <textarea name="description" class="form-control" v-on:input="checkDescription()" data-vv-as="descrição" v-validate="'required'" v-model="form.description"
                            placeholder="Use este campo para nos dar quaisquer detalhes ou preferências que você tem sobre o lugar que está buscando. Não informe seus dados pessoais como email ou números de telefone. Por exemplo: Procuro uma casa com quarto individual. Trabalho durante o dia e estudo durante a noite. Irei passar a maior parte do dia fora, mas quero ter algum lugar tranquilo para descansar. Gostaria de ter acesso a internet no imóvel. Se possível, gostaria de ter uma vaga no estacionamento para deixar meu carro também." cols="30" rows="10"></textarea>
                        <span class="help-block text-left text-danger m-t-10" v-if="has_phone">
                            <i class="fas fa-exclamation-triangle m-r-10"></i> <strong>Nossa equipe revisa e remove todos os números de telefone e emails preenchidos neste campo. Para sua própria segurança, use sempre o chat do WebQuarto para conversar com os anunciantes dos quartos que você se interessar.</strong>
                        </span>
                        <span class="help-block text-left" v-show="errors.has('description')">
                            <strong>{{ errors.first('description') }}</strong>
                        </span>
                    </div>
                </div>
            </div>

            <div class="row m-t-20">
                <div class="col-xs-12">
                    <div class="form-group account-btn text-right">
                        <button @click="goBack" class="btn btn-clear btn-white pull-left">Voltar</button>
                        <button @click="submit()" class="btn btn-bordered btn-success waves-effect waves-light w-lg ladda-button btn-submit" type="submit">Continuar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Money} from '../../../../../../legacy/node_modules/v-money';
import {mask} from '../../../../../../legacy/node_modules/vue-the-mask';
import DatePicker from '../../../../../../legacy/node_modules/vue2-datepicker';
import '../../../../../../legacy/node_modules/vue2-datepicker/index.css';
export default {
    components: {Money, DatePicker},
    directives: {mask},
    props: ['obj'],
    data: function () {
        return {
            open_picker: false,
            has_phone: false,
            money: {
				decimal: ',',
				thousands: '.',
				prefix: 'R$ ',
				suffix: '',
				precision: 2,
				masked: false
            },
            local_fields: ['rent_price', 'description'],
            form: this.obj
        };
    },
    computed: {
        amenities: function () {
            return [];
        }
    },
    methods: {
        checkDescription: function () {
			this.has_phone = this.form.description.match(/([0-9]{4,5}[- .][0-9]{4})|([0-9]{8})|(([0-9]\s?){8})|(whats)|(fone)/);
		},
        goBack: function () {
            this.$emit('goback');
        },
        submit: function () {
            let _this = this;
            this.$validator.validateAll().then(function (res) {
                if (!res)
                    return false;

                _this.$emit('submit', _this.form);
                window.scrollTo(0,0);
            });
        },
        disabledDate(date) {
            var d = new Date().setHours(0,0,0,0);
            return date < d;
        },
        dateChange() {
            this.open_picker = false;
        }
    },
    mounted() {}
}
</script>

<style lang="scss">
    .mx-datepicker-popup { z-index: 1060; }
    .mx-datepicker {
        width: 100% !important;
    }
</style>